import {Text} from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import {sendActionPanelRequest} from '../../vuplex';
import GenericCard from './GenericCard';
import WikipediaLogo from '../../assets/WikipediaLogo.png';


const sendActionPanelDebounced = _.debounce((props, isAutoClose) => {
  sendActionPanelRequest(props, isAutoClose);
}, 1000, {leading: true, trailing: false});

const WikipediaCard = ({
  wikiPage,
}) => {
  const {
    coordinates: [{lat, lon}],
    description,
    pageid: wikiPageId,
    thumbnail: {source: photoUrl} = {source: ''},
    title,
  } = wikiPage;

  return (
    <GenericCard
      backgroundColor="whiteAlpha.600"
      description={<Text fontSize="sm">{description}</Text>}
      detailsPath={`./${wikiPageId}`}
      h="14em"
      iconUrl={`${window.location.origin}${WikipediaLogo}`}
      isPhotoBackground
      latitude={lat}
      longitude={lon}
      // name={title}
      onClickPin={() => {
        sendActionPanelDebounced({
          actionPanelTool: 'wikiActionPanelContent',
          wikipedia: {
            photoUrl,
            title,
            wikiPageId,
          }
        }, false)
      }}
      photoUrl={photoUrl}
      pinTooltip={`${title} <br> Click for details  <br> (Only visible to you)`}
      placeType={'wiki'}
    />
  );
};

export default WikipediaCard;
